'use strict';

import jQuery from 'jquery';

var PostModel = (function ($) {

  var defaultState = {
    content: {},
    updated: 0
  };

  // Define a new PostModel function
  function PostModel(initialState) {

    // Define the default empty state for the model
    this._state = $.extend({}, defaultState, initialState);
  }

  /**
   * Gets the post specific content from the model
   *
   * @returns {object} Returns an object of the currently fetched content
   */
  PostModel.prototype.getContent = function getContent() {

    // Return the state
    return this._state.content;
  };

  /**
   * Sets the post specific content for the model
   *
   * @returns {object} Returns an object of the currently set content
   */
  PostModel.prototype.setContent = function setContent(content) {

    // Set the content data
    this._state.content = content;

    // Return the state
    return this._state.content;
  };

  /**
   * Returns a JSON representation of model
   *
   * @returns {{content: Object, social: Object}}
   */
  PostModel.prototype.toJSON = function toJSON() {

    return {
      content: this.getContent()
    };
  };

  return PostModel;
})(jQuery);

export default PostModel;